import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { CardContext, CellContext, forceMobile } from '../generics';
import ProductTableCellBase from './cell-base';
import ProductTableCellCta from './cell-cta';
import ProductTableCellImage from './cell-image';
import { ROWS } from './cell-split';
import RowWrapper from './row-wrapper';
import Header from './header';
import { ProductTableHeaderBanner } from './header-banner';
import { WireFrame } from './wireframe-cell';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var ProductTableRow = function ProductTableRow(_ref) {
  var _ref$badges = _ref.badges,
      badges = _ref$badges === void 0 ? [] : _ref$badges,
      preTitle = _ref.preTitle,
      rowTitle = _ref.rowTitle,
      subtitle = _ref.subtitle,
      _ref$addons = _ref.addons,
      addons = _ref$addons === void 0 ? [] : _ref$addons,
      children = _ref.children,
      id = _ref.id,
      clickableRow = _ref.clickableRow,
      image = _ref.image,
      disabled = _ref.disabled,
      _ref$card = _ref.card,
      card = _ref$card === void 0 ? false : _ref$card,
      _ref$preApproved = _ref.preApproved,
      preApproved = _ref$preApproved === void 0 ? false : _ref$preApproved,
      bannerInfo = _ref.bannerInfo,
      onBannerClick = _ref.onBannerClick,
      _ref$extraStyles = _ref.extraStyles,
      extraStyles = _ref$extraStyles === void 0 ? {} : _ref$extraStyles,
      _ref$sectionStyles = _ref.sectionStyles,
      sectionStyles = _ref$sectionStyles === void 0 ? {} : _ref$sectionStyles,
      onRowClick = _ref.onRowClick,
      _ref$isWireFrame = _ref.isWireFrame,
      isWireFrame = _ref$isWireFrame === void 0 ? false : _ref$isWireFrame;
  var forcedMobile = forceMobile(card);

  var addonsFor = function addonsFor(key) {
    return addons.map(function (_ref2, i) {
      var addon = _ref2.addon,
          component = _ref2.component,
          options = _ref2.options;
      options = Object.assign({}, addon.defaultArguments, options); // @todo why isn't the check in the responsive addon doing this?

      if (options.positions && !options.positions.includes(key)) {
        return null;
      }

      if (addon[key]) {
        var AddonPart = addon[key];
        return _jsx(AddonPart, _objectSpread(_objectSpread({}, options), {}, {
          children: component
        }), i);
      }
    });
  }; // @todo All addons go at the start - is there a better way to do this?


  var nonNullChildren = addonsFor('grid').concat(React.Children.toArray(children)).filter(function (c) {
    return c;
  }); // When disabled, replace CTA with empty base cell

  if (disabled) {
    nonNullChildren = nonNullChildren.filter(function (child) {
      return child.type !== ProductTableCellCta;
    }); // eslint-disable-next-line react/jsx-key

    nonNullChildren = [].concat(_toConsumableArray(nonNullChildren), [_jsx(ProductTableCellBase, {})]);
  }

  var accentCells = nonNullChildren.filter(function (child) {
    return child.props.accent;
  });

  if (accentCells.length > 2) {
    throw new Error('Primary cell count cannot be above two');
  }

  var cols = nonNullChildren.length;
  var hasCellImage = nonNullChildren.map(function (child) {
    return child.type;
  }).includes(ProductTableCellImage);
  /**
   * Row numbers explained:
   *
   * ROW 1: reserved for addons above header (auto height)
   * ROW 2: used for header
   * ROW 3: reserved for addons below header (auto height)
   * ROW 4-9: used for grid
   * ROW 10-12: reserved for addons below grid (footer addon uses 11)
   */

  return _jsx(CardContext.Provider, {
    value: {
      isCard: card
    },
    children: _jsxs("section", {
      id: id,
      sx: _objectSpread({
        position: 'relative',
        border: '1px solid',
        marginTop: badges.length ? [10, 15] : 0,
        marginBottom: 'md',
        ':last-of-type': {
          marginBottom: 0
        },
        variant: image ? 'compounds.product-table.variants.redesign.row.main' : 'compounds.product-table.row.main',
        pointerEvents: disabled || isWireFrame ? 'none' : null,
        opacity: disabled ? '0.5' : '1',
        width: '100%'
      }, sectionStyles),
      children: [preApproved && bannerInfo && _jsx(ProductTableHeaderBanner, {
        bannerInfo: bannerInfo,
        badge: !!badges.length,
        onClick: function onClick() {
          return onBannerClick && onBannerClick();
        }
      }), _jsxs(RowWrapper, {
        link: clickableRow,
        headerImage: image,
        onRowClick: onRowClick,
        sx: {
          variant: 'compounds.product-table.row.wrapper'
        },
        children: [!!badges.length && _jsx("div", {
          sx: {
            position: 'absolute',
            top: 0,
            transform: 'translateY(-50%)',
            width: '100%',
            variant: 'compounds.product-table.row.badge-wrapper'
          },
          children: badges.map(function (badge, i) {
            return _jsx("span", {
              sx: {
                marginRight: 'sm'
              },
              children: badge
            }, i);
          })
        }), _jsx(Header, {
          badges: badges,
          image: image,
          preTitle: preTitle,
          rowTitle: rowTitle,
          subtitle: subtitle,
          addons: addonsFor('header'),
          card: card,
          isWireFrame: isWireFrame
        }), _jsxs("div", {
          sx: _objectSpread(_objectSpread({
            display: 'grid',
            gridTemplateColumns: forcedMobile(['repeat(2, 1fr)', null, "repeat(".concat(image ? cols - 1 : cols, ", 1fr)")]),
            msGridColumns: forcedMobile(['(1fr)[2]', null, "(1fr)[".concat(image ? cols - 1 : cols, "]")]),
            gridTemplateRows: forcedMobile(['auto', null, "repeat(3, auto) repeat(".concat(ROWS, ", 1fr) repeat(3, auto)")]),
            msGridRows: forcedMobile(['auto', null, "(auto)[3] (1fr)[".concat(ROWS, "] (auto)[3]")]),
            marginX: -8,
            marginY: -6,
            marginTop: image ? 0 : -6,
            variant: 'compounds.product-table.row.grid'
          }, extraStyles), {}, {
            // Flex in mobile IE11 (?!) as auto-layout for grid isn't supported
            '@media all and (max-width: 990px) and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
              display: 'flex',
              flexDirection: 'column'
            }
          }) // @ts-ignore
          ,
          css: !card && {
            display: '-ms-grid'
          },
          children: [nonNullChildren.map(function (child, index) {
            return _jsx(CellContext.Provider, {
              value: {
                gridRowStart: 4,
                gridRowSpan: ROWS,
                gridColumnStart: image && hasCellImage && child.type === ProductTableCellCta ? index : index + 1,
                gridColumnSpan: 1,
                accentCellCount: accentCells.length,
                accentCellIndex: child.props.accent && accentCells.indexOf(child),
                extraRules: {
                  variant: image && child.type !== ProductTableCellCta && "compounds.product-table.variants.redesign.cellContext.".concat(hasCellImage ? 'variants.cellImage' : card ? 'variants.card' : 'main')
                }
              },
              children: child
            }, index);
          }), isWireFrame && _jsx(WireFrame, {
            type: "info"
          }), isWireFrame && _jsx(WireFrame, {
            type: "example"
          }), !isWireFrame && _jsx(CellContext.Provider, {
            value: {
              gridRowStart: 1,
              gridRowSpan: ROWS,
              gridColumnStart: 1,
              gridColumnSpan: cols
            },
            children: addonsFor('body')
          })]
        })]
      })]
    })
  });
};

export default ProductTableRow;
//# sourceMappingURL=row.js.map